module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "main-con"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "nav-bar"
  }, [_c('router-link', {
    staticClass: "btn-nav",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn-nav",
    attrs: {
      "to": {
        name: 'product'
      }
    }
  }, [_vm._v("平台产品")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn-nav",
    attrs: {
      "to": {
        name: 'service'
      }
    }
  }, [_vm._v("平台服务")]), _vm._v(" "), _c('a', {
    staticClass: "btn-nav",
    attrs: {
      "href": "http://open.zizai.thinkinpower.com/#/support",
      "target": "_blank"
    }
  }, [_vm._v("平台合作")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn-nav",
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn-nav",
    attrs: {
      "to": {
        name: 'download'
      }
    }
  }, [_vm._v("下载")])], 1)])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("./assets/images/icon_logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("自在生活")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "main-con"
  }, [_c('div', [_c('span', [_vm._v("商务合作：biz@thinkinpower.com")]), _vm._v("   |  \n        "), _c('span', [_vm._v("意见反馈：service@thinkinpower.com")]), _vm._v("   |  \n        "), _c('span', [_vm._v("联系电话：020-38882777")]), _vm._v("   |  \n        "), _c('span', [_vm._v("地址：广州市天河区珠江新城华夏路10号富力中心35楼3503室")])]), _vm._v(" "), _c('div', [_vm._v("\n        COPYRIGHT © 2017 ThinkinPower,ALL RIGHT RESERVED."), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.miitbeian.gov.cn/"
    }
  }, [_vm._v("粤ICP备16101578号")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/._vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-c7d7c370"}!./~/._vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 390
// module chunks = 7